import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import RecommendedArtists from '../components/cards/aside/recommended-artists';
import EmptyCard from '../components/cards/empty.card';
import Container from '../components/containers/container';
import FeedsContainer from '../components/containers/feeds.container';
import Header from '../components/header/default.header';
import { VStack } from '../components/layouts/stack.layout';
import MainLayout from '../components/layouts/v2/main.layout';
import AlternativeNavigation from '../components/navigation/alternative.navigation';
import Search from '../components/overlay/search';
import { feedsState } from '../recoil/feeds/feeds.state';

export default function Bookmarks() {
  const feedData = useRecoilValue(feedsState);

  const bookmarkedFeeds = [...feedData].filter((feed) => feed.bookmarked);

  useEffect(() => {
    document.title = 'The Base | Bookmarks';
  }, []);

  return (
    <MainLayout>
      <MainLayout.Header>
        <Header />
      </MainLayout.Header>
      <MainLayout.Content>
        <MainLayout.Navigation>
          <AlternativeNavigation />
        </MainLayout.Navigation>
        <MainLayout.Main>
          {/** make this one component and remove prop passing*/}
          <Container extensions="relative">
            {!bookmarkedFeeds.length && <EmptyCard variant="bookmarks" />}
            {bookmarkedFeeds.length > 0 && (
              <FeedsContainer query={['BOOKMARKS']} />
            )}
          </Container>
        </MainLayout.Main>
      </MainLayout.Content>
      <MainLayout.Aside>
        <VStack gap="md">
          <Container extensions="w-full pb-2 px-[40px] pr-[50px]">
            <Search />
          </Container>
          <RecommendedArtists />
        </VStack>
      </MainLayout.Aside>
    </MainLayout>
  );
}
